export type Lang = "en" | "es";

export const translations = {
  nav: {
    home: { en: "Home", es: "Inicio" },
    services: { en: "Services", es: "Servicios" },
    process: { en: "Process", es: "Proceso" },
    ourWork: { en: "Our Work", es: "Nuestro Trabajo" },
    getEstimate: { en: "Get Estimate", es: "Obtener Estimado" },
    blog: { en: "Blog", es: "Blog" },
    events: { en: "Events", es: "Eventos" },
    more: { en: "More", es: "Más" },
    resources: { en: "Resources", es: "Recursos" },
    areas: { en: "Areas", es: "Áreas" },
    buildYourAdu: { en: "Build Your ADU", es: "Construye tu ADU" },
    aduBuilder: { en: "ADU Builder San Diego", es: "Constructor de ADU San Diego" },
    garageConversion: { en: "Garage Conversion ADU", es: "Conversión de Garaje a ADU" },
    aduFinancing: { en: "ADU Financing", es: "Financiamiento de ADU" },
    aduCostGuide: { en: "ADU Cost Guide 2026", es: "Guía de Costos ADU 2026" },
    roiCalculator: { en: "ROI Calculator", es: "Calculadora ROI" },
    glossary: { en: "ADU Glossary", es: "Glosario ADU" },
    seeAllFinancing: { en: "See All Financing Options", es: "Ver Todas las Opciones de Financiamiento" },
    freeConsultation: { en: "Unlock Free Consultation", es: "Desbloquea Consulta Gratis" },
  },
  hero: {
    badge: { en: "See if your property qualifies for an ADU", es: "¿Vea si su propiedad califica para una ADU?" },
    headline1: { en: "ADU Builder", es: "Constructor de ADU" },
    headline2: { en: "in San Diego", es: "en San Diego" },
    subtitle: {
      en: "Licensed San Diego ADU builder (CA Lic #864642) with 50+ completed projects and 4.8★ Google reviews. From design and permits to move-in — full-service ADU construction in 60 days.",
      es: "Constructor de ADU licenciado en San Diego (Lic CA #864642) con más de 50 proyectos completados y 4.8★ en Google. Desde el diseño y permisos hasta la mudanza — construcción de ADU de servicio completo en 60 días.",
    },
    cta: { en: "Unlock Estimate", es: "Desbloquea Estimado" },
    trust: {
      licensed: { en: "Licensed & Insured", es: "Licenciado y Asegurado" },
      reviews: { en: "4.8-Star Google Reviews", es: "Reseñas 4.8 Estrellas en Google" },
      response: { en: "Response in 24h", es: "Respuesta en 24h" },
      area: { en: "San Diego County", es: "Condado de San Diego" },
    },
    socialProof: { en: "50+ happy San Diego homeowners", es: "50+ propietarios satisfechos en San Diego" },
  },
  stats: {
    adus: { en: "ADUs Built", es: "ADUs Construidos" },
    experience: { en: "Years Experience", es: "Años de Experiencia" },
    rating: { en: "Google Rating", es: "Calificación Google" },
    buildTime: { en: "Day Build Time*", es: "Días de Construcción*" },
  },
  services: {
    sectionLabel: { en: "What We Do", es: "Lo Que Hacemos" },
    sectionTitle: { en: "Full-Service ADU Construction", es: "Construcción de ADU Servicio Completo" },
    sectionDesc: {
      en: "We manage every step of your ADU project — from the first sketch to handing you the keys.",
      es: "Manejamos cada paso de su proyecto de ADU — desde el primer boceto hasta entregarle las llaves.",
    },
    cta: { en: "Learn the Full ADU Process", es: "Conoce el Proceso Completo Para Tu ADU" },
    items: [
      {
        title: { en: "Design", es: "Diseño" },
        desc: {
          en: "Custom ADU designs tailored to your property. We create floor plans and 3D renderings that maximize space and value.",
          es: "Diseños de ADU personalizados para su propiedad. Creamos planos y renders 3D que maximizan el espacio y el valor.",
        },
      },
      {
        title: { en: "Planning", es: "Planificación" },
        desc: {
          en: "We handle feasibility analysis, project timelines, and budget coordination so your ADU project stays on track from day one.",
          es: "Manejamos el análisis de viabilidad, cronogramas del proyecto y coordinación de presupuesto para que su proyecto de ADU avance sin contratiempos desde el primer día.",
        },
      },
      {
        title: { en: "Permits & Approvals", es: "Permisos y Aprobaciones" },
        desc: {
          en: "We handle all San Diego city permits, HOA approvals, and inspections so you don't have to.",
          es: "Manejamos todos los permisos de la ciudad de San Diego, aprobaciones de HOA e inspecciones para que usted no tenga que hacerlo.",
        },
      },
      {
        title: { en: "Full Construction", es: "Construcción Completa" },
        desc: {
          en: "End-to-end construction by licensed contractors. On time, on budget — guaranteed.",
          es: "Construcción de principio a fin por contratistas licenciados. A tiempo, dentro del presupuesto — garantizado.",
        },
      },
    ],
  },
  testimonials: {
    sectionLabel: { en: "What Homeowners Say", es: "Lo Que Dicen Los Propietarios" },
    sectionTitle: { en: "We Care About Your Family's Satisfaction", es: "Nos Importa La Satisfacción De Su Familia" },
    sectionDesc: {
      en: "Real reviews from San Diego homeowners who trusted us with their ADU.",
      es: "Reseñas reales de propietarios de San Diego que confiaron en nosotros para su ADU.",
    },
  },
  process: {
    sectionLabel: { en: "How It Works", es: "Cómo Funciona" },
    sectionTitle: { en: "This Is Our Process to Build Your ADU", es: "Este Es Nuestro Proceso Para Construir Su ADU" },
    sectionDesc: {
      en: "A proven, stress-free process from first call to move-in day.",
      es: "Un proceso probado y sin estrés desde la primera llamada hasta el día de mudanza.",
    },
    timelapse: {
      en: "Watch an ADU go from foundation to finished in 60 days",
      es: "Vea una ADU ir de los cimientos a terminada en 60 días",
    },
    cta: { en: "Start Your ADU Project", es: "Comience Su Proyecto de ADU" },
    steps: [
      {
        title: { en: "Free Consultation", es: "Consulta Gratis" },
        desc: {
          en: "We assess your property, discuss your goals, and provide a detailed estimate — completely free and with no obligation.",
          es: "Evaluamos su propiedad, discutimos sus metas y proporcionamos un estimado detallado — completamente gratis y sin compromiso.",
        },
      },
      {
        title: { en: "Design", es: "Diseño" },
        desc: {
          en: "Our designers create a custom floor plan optimized for your lot and budget. We handle revisions until you love it.",
          es: "Nuestros diseñadores crean un plano personalizado optimizado para su lote y presupuesto. Hacemos revisiones hasta que le encante.",
        },
      },
      {
        title: { en: "Permits & Approvals", es: "Permisos y Aprobaciones" },
        desc: {
          en: "We submit and manage all city permits, saving you months of back-and-forth with the city.",
          es: "Presentamos y manejamos todos los permisos de la ciudad, ahorrándole meses de trámites.",
        },
      },
      {
        title: { en: "Construction", es: "Construcción" },
        desc: {
          en: "Our licensed crews build your ADU efficiently. You get weekly updates and full transparency throughout.",
          es: "Nuestros equipos licenciados construyen su ADU eficientemente. Recibe actualizaciones semanales y total transparencia.",
        },
      },
      {
        title: { en: "Final Inspection", es: "Inspección Final" },
        desc: {
          en: "We pass all inspections and hand over your finished ADU, ready for occupancy or rental.",
          es: "Pasamos todas las inspecciones y le entregamos su ADU terminada, lista para ocupar o alquilar.",
        },
      },
    ],
  },
  benefits: {
    sectionLabel: { en: "Why EG Construction", es: "Por Qué EG Construction" },
    sectionTitle1: { en: "This Is What You Get When You", es: "Esto Es Lo Que Obtiene Cuando" },
    sectionTitle2: { en: "Trust EG Construction", es: "Confía en EG Construction" },
    sectionTitle3: { en: "to Build Your ADU", es: "Para Construir Su ADU" },
    items: [
      {
        title: { en: "Licensed & Insured", es: "Licenciado y Asegurado" },
        desc: {
          en: "CA Contractor License #864642. Fully insured for your peace of mind.",
          es: "Licencia de Contratista CA #864642. Totalmente asegurado para su tranquilidad.",
        },
      },
      {
        title: { en: "ADU in 60 Days*", es: "ADU en 60 Días*" },
        desc: {
          en: "Industry-leading build times. Most ADUs completed in 60 business days from permit approval.",
          es: "Tiempos de construcción líderes en la industria. La mayoría de ADUs completadas en 60 días hábiles desde la aprobación del permiso.",
        },
      },
      {
        title: { en: "Price Guarantee", es: "Precio Garantizado" },
        desc: {
          en: "No hidden fees. The price we quote is the price you pay — period.",
          es: "Sin cargos ocultos. El precio que cotizamos es el precio que paga — punto.",
        },
      },
      {
        title: { en: "Full Project Management", es: "Gestión Completa del Proyecto" },
        desc: {
          en: "One point of contact from design to completion. We handle design, permits, and construction.",
          es: "Un solo punto de contacto desde el diseño hasta la finalización. Manejamos diseño, permisos y construcción.",
        },
      },
    ],
  },
  faq: {
    sectionLabel: { en: "FAQ", es: "Preguntas Frecuentes" },
    sectionTitle: {
      en: "Frequently Asked Questions About Building an ADU",
      es: "Preguntas Frecuentes Sobre Construir una ADU",
    },
    sectionDesc: {
      en: "Everything you need to know about the ADU process in San Diego.",
      es: "Todo lo que necesita saber sobre el proceso de ADU en San Diego.",
    },
    moreQuestions: { en: "Have more questions? We're happy to help.", es: "¿Tiene más preguntas? Estamos felices de ayudar." },
    ctaButton: { en: "Get a Free Consultation", es: "Obtenga Una Consulta Gratis" },
    items: [
      {
        q: { en: "How much does it cost to build an ADU in San Diego?", es: "¿Cuánto cuesta construir una ADU en San Diego?" },
        a: {
          en: "ADU costs in San Diego typically range from $150,000 to $350,000+ depending on size, type (detached vs. attached), and finishes. Contact us for a free, detailed estimate specific to your property.",
          es: "Los costos de ADU en San Diego generalmente van desde $150,000 hasta $350,000+ dependiendo del tamaño, tipo (independiente vs. adjunta) y acabados. Contáctenos para un estimado gratuito y detallado específico para su propiedad.",
        },
      },
      {
        q: { en: "How long does it take to build an ADU?", es: "¿Cuánto tiempo toma construir una ADU?" },
        a: {
          en: "From permit approval, most of our ADUs are completed in 60 business days. The full timeline including permits is typically 4–8 months depending on city processing times.",
          es: "Desde la aprobación del permiso, la mayoría de nuestras ADUs se completan en 60 días hábiles. El cronograma completo incluyendo permisos es típicamente de 4 a 8 meses dependiendo de los tiempos de procesamiento de la ciudad.",
        },
      },
      {
        q: { en: "Do I need permits to build an ADU in San Diego?", es: "¿Necesito permisos para construir una ADU en San Diego?" },
        a: {
          en: "Yes, permits are required. EG Construction handles the entire permit process for you — from application submission to final inspection approval.",
          es: "Sí, se requieren permisos. EG Construction maneja todo el proceso de permisos por usted — desde la presentación de la solicitud hasta la aprobación de la inspección final.",
        },
      },
      {
        q: { en: "What types of ADUs do you build?", es: "¿Qué tipos de ADUs construyen?" },
        a: {
          en: "We build detached ADUs, attached ADUs, garage conversions (ADGUs), and Junior ADUs (JADUs). We serve all of San Diego County.",
          es: "Construimos ADUs independientes, adjuntas, conversiones de garaje (ADGUs) y ADUs Junior (JADUs). Servimos a todo el condado de San Diego.",
        },
      },
      {
        q: { en: "Can I rent my ADU immediately after construction?", es: "¿Puedo rentar mi ADU inmediatamente después de la construcción?" },
        a: {
          en: "Yes. Once we obtain the final Certificate of Occupancy, your ADU is legal to rent. San Diego ADUs typically generate $1,500–$3,000/month in rental income.",
          es: "Sí. Una vez que obtenemos el Certificado de Ocupación final, su ADU es legal para rentar. Las ADUs en San Diego típicamente generan $1,500–$3,000/mes en ingresos por alquiler.",
        },
      },
      {
        q: { en: "Who is the best ADU builder in San Diego?", es: "¿Quién es el mejor constructor de ADU en San Diego?" },
        a: {
          en: "EG Construction is a top-rated ADU builder in San Diego County with 50+ completed ADUs, a 4.8★ rating, California Contractor License #864642, a 60-day move-in promise, and a written price guarantee. Founded by Elias Gutierrez with 20+ years of construction experience.",
          es: "EG Construction es un constructor de ADU mejor calificado en el Condado de San Diego con más de 50 ADUs completadas, calificación 4.8★, Licencia de Contratista de California #864642, promesa de mudanza en 60 días y garantía de precio por escrito. Fundado por Elias Gutierrez con más de 20 años de experiencia.",
        },
      },
      {
        q: { en: "Can I add an ADU to my property in San Diego?", es: "¿Puedo añadir una ADU a mi propiedad en San Diego?" },
        a: {
          en: "In most cases yes. California state law (AB 68 and follow-up legislation) allows ADUs on virtually every single-family lot in San Diego County, and most cities allow at least one ADU plus one JADU per parcel. We verify your specific zoning and lot constraints on the discovery call.",
          es: "En la mayoría de los casos sí. La ley estatal de California (AB 68 y legislación posterior) permite ADUs en prácticamente cualquier lote unifamiliar en el Condado de San Diego, y la mayoría de las ciudades permiten al menos una ADU más una JADU por parcela. Verificamos su zonificación específica en la llamada de descubrimiento.",
        },
      },
      {
        q: { en: "How much value does an ADU add to my San Diego home?", es: "¿Cuánto valor añade una ADU a mi casa en San Diego?" },
        a: {
          en: "Appraisers in San Diego typically add 70%–100% of the ADU's construction cost to property value, plus rental income of $1,500–$3,000/month. A $250,000 ADU often increases home value by $200,000–$300,000 while paying for itself within 8–12 years.",
          es: "Los tasadores en San Diego suelen añadir entre 70% y 100% del costo de construcción de la ADU al valor de la propiedad, más ingresos de alquiler de $1,500–$3,000/mes. Una ADU de $250,000 suele aumentar el valor de la casa entre $200,000 y $300,000 mientras se paga sola en 8 a 12 años.",
        },
      },
      {
        q: { en: "Do you handle the permit process for me?", es: "¿Ustedes manejan el proceso de permisos por mí?" },
        a: {
          en: "Yes. EG Construction manages the entire permit process end-to-end — site plans, structural drawings, MEP, Title 24, submittal to the city, corrections, and final inspections. You sign one contract; we deliver a permitted, finaled ADU.",
          es: "Sí. EG Construction maneja todo el proceso de permisos de principio a fin — planos del sitio, estructurales, MEP, Title 24, presentación a la ciudad, correcciones e inspecciones finales. Usted firma un contrato; nosotros entregamos una ADU permitida y aprobada.",
        },
      },
      {
        q: { en: "What financing options are available for ADUs?", es: "¿Qué opciones de financiamiento hay para ADUs?" },
        a: {
          en: "Common options include HELOC, cash-out refinance, construction-to-permanent loans, and specialty ADU loans that underwrite future rental income. EG Construction does not lend directly but connects clients with vetted San Diego ADU lenders.",
          es: "Las opciones comunes incluyen HELOC, refinanciamiento con retiro de efectivo, préstamos de construcción a permanente y préstamos especializados para ADU que califican usando el alquiler futuro. EG Construction no presta directamente pero conecta clientes con prestamistas vetados de ADU en San Diego.",
        },
      },
      {
        q: { en: "Do you offer pre-designed floor plans or custom design?", es: "¿Ofrecen planos prediseñados o diseño personalizado?" },
        a: {
          en: "Both. Our pre-designed floor plan library gives you a faster, more predictable build at a fixed price. We also offer full custom architectural design for unique lots, hillsides, or specific multigenerational needs.",
          es: "Ambos. Nuestra biblioteca de planos prediseñados ofrece una construcción más rápida y predecible a precio fijo. También ofrecemos diseño arquitectónico totalmente personalizado para lotes únicos, laderas o necesidades multigeneracionales específicas.",
        },
      },
      {
        q: { en: "Can I build an ADU if my property has an HOA in San Diego?", es: "¿Puedo construir una ADU si mi propiedad tiene HOA en San Diego?" },
        a: {
          en: "In most cases yes. California Civil Code §4751 prevents HOAs from unreasonably restricting or prohibiting the construction of an ADU or JADU on a single-family lot. HOAs can enforce reasonable design guidelines, but they cannot outright ban ADUs. We help review your CC&Rs during the discovery call.",
          es: "En la mayoría de los casos sí. El Código Civil de California §4751 impide que los HOA restrinjan o prohíban de forma irrazonable la construcción de una ADU o JADU en un lote unifamiliar. Los HOA pueden hacer cumplir pautas de diseño razonables, pero no pueden prohibir las ADUs por completo. Revisamos sus CC&Rs en la llamada de descubrimiento.",
        },
      },
      {
        q: { en: "What is the difference between a JADU and an ADU in California?", es: "¿Qué diferencia hay entre una JADU y una ADU en California?" },
        a: {
          en: "A JADU (Junior ADU) is up to 500 sq ft built within the existing walls of the primary home, typically converting a bedroom, and requires the owner to live on the property. A standard ADU can be up to 1,200 sq ft, detached or attached, has its own utility connections, and does not require owner-occupancy. Many San Diego lots can legally have one ADU plus one JADU.",
          es: "Una JADU (ADU Junior) es de hasta 500 pies cuadrados construida dentro de los muros existentes de la casa principal, generalmente convirtiendo una habitación, y requiere que el propietario viva en la propiedad. Una ADU estándar puede tener hasta 1,200 pies cuadrados, independiente o adjunta, tiene sus propias conexiones de servicios y no requiere ocupación del propietario. Muchos lotes en San Diego pueden tener legalmente una ADU más una JADU.",
        },
      },
      {
        q: { en: "Can I have two ADUs on a single property in San Diego?", es: "¿Puedo tener dos ADUs en una sola propiedad en San Diego?" },
        a: {
          en: "Yes. Under current California law, a single-family lot in San Diego can typically have one detached ADU plus one JADU, and multi-family properties can add even more units. The City of San Diego also allows bonus ADUs in certain transit-priority areas. We confirm exact limits for your parcel during the discovery call.",
          es: "Sí. Bajo la ley actual de California, un lote unifamiliar en San Diego típicamente puede tener una ADU independiente más una JADU, y las propiedades multifamiliares pueden agregar aún más unidades. La Ciudad de San Diego también permite ADUs bonus en ciertas áreas prioritarias de tránsito. Confirmamos los límites exactos de su parcela en la llamada de descubrimiento.",
        },
      },
      {
        q: { en: "Do I have to live on the property to build an ADU in San Diego?", es: "¿Tengo que vivir en la propiedad para construir una ADU en San Diego?" },
        a: {
          en: "No — for standard ADUs, California suspended the owner-occupancy requirement through 2025 and it remains lifted for new ADUs permitted before that sunset. JADUs still require the owner to occupy either the main home or the JADU. This makes ADUs attractive as pure rental investments for out-of-area landlords.",
          es: "No — para ADUs estándar, California suspendió el requisito de ocupación del propietario hasta 2025 y sigue levantado para nuevas ADUs permitidas antes de esa fecha. Las JADUs aún requieren que el propietario ocupe la casa principal o la JADU. Esto hace que las ADUs sean atractivas como inversiones de renta pura para propietarios fuera del área.",
        },
      },
    ],
  },
  video: {
    sectionLabel: { en: "Watch & Learn", es: "Mire y Aprenda" },
    sectionTitle: { en: "Is Building an ADU a Good Idea?", es: "¿Es Buena Idea Construir una ADU?" },
    sectionDesc: {
      en: "In this video we break down whether building an ADU makes financial sense for San Diego homeowners — covering costs, rental income potential, and the permit process.",
      es: "En este video analizamos si construir una ADU tiene sentido financiero para los propietarios de San Diego — cubriendo costos, potencial de ingresos por alquiler y el proceso de permisos.",
    },
    cta: { en: "Schedule Your Discovery Call", es: "Agenda Tu Llamada de Descubrimiento" },
  },
  serviceAreas: {
    sectionLabel: { en: "Where We Build", es: "Dónde Construimos" },
    sectionTitle: { en: "Areas We Serve in San Diego County", es: "Áreas Que Servimos en el Condado de San Diego" },
    sectionDesc: {
      en: "We build ADUs across the entire San Diego region. If you don't see your city, contact us — we likely serve your area.",
      es: "Construimos ADUs en toda la región de San Diego. Si no ve su ciudad, contáctenos — probablemente servimos su área.",
    },
  },
  ctaBand: {
    title: { en: "Ready to Build Your ADU?", es: "¿Listo Para Construir Su ADU?" },
    desc: {
      en: "Get a free, no-obligation quote from San Diego's most trusted ADU builders. Se habla Español.",
      es: "Obtenga una cotización gratis y sin compromiso de los constructores de ADU más confiables de San Diego. Se habla Español.",
    },
    cta: { en: "Get Estimate", es: "Obtener Estimado" },
    call: { en: "Call +1 619-815-4787", es: "Llame al +1 619-815-4787" },
  },
  footer: {
    tagline: {
      en: "San Diego's trusted ADU builder. Your home, your future, our promise.",
      es: "El constructor de ADU de confianza de San Diego. Su hogar, su futuro, nuestra promesa.",
    },
    quickLinks: { en: "Quick Links", es: "Enlaces Rápidos" },
    contact: { en: "Contact", es: "Contacto" },
    privacy: { en: "Privacy Policy", es: "Política de Privacidad" },
    terms: { en: "Terms of Service", es: "Términos de Servicio" },
  },
  modal: {
    title: { en: "Schedule an ADU Consultation", es: "Agende una Consulta de ADU" },
    desc: { en: "No commitment · Fast response · 100% free", es: "Sin compromiso · Respuesta rápida · 100% gratis" },
  },
  financing: {
    sectionLabel: { en: "Financing", es: "Financiamiento" },
    sectionTitle: { en: "Need Help Financing Your ADU?", es: "¿Necesita Ayuda Para Financiar Su ADU?" },
    sectionDesc: {
      en: "While we don't offer in-house financing, we work with trusted lending partners who specialize in ADU and home improvement loans. Let us connect you with the right lender to make your ADU project a reality.",
      es: "Aunque no ofrecemos financiamiento propio, trabajamos con socios prestamistas de confianza que se especializan en préstamos para ADU y mejoras del hogar. Permítanos conectarlo con el prestamista adecuado para hacer realidad su proyecto de ADU.",
    },
    cta: { en: "Get Connected to a Lender", es: "Conéctese con un Prestamista" },
  },
  projects: {
    pageTitle: { en: "Our Projects", es: "Nuestros Proyectos" },
    pageDesc: {
      en: "Explore our completed ADU projects across San Diego County. See real results, specs, and photos.",
      es: "Explore nuestros proyectos de ADU completados en el condado de San Diego. Vea resultados reales, especificaciones y fotos.",
    },
    viewProject: { en: "View Project", es: "Ver Proyecto" },
    sqft: { en: "sqft", es: "pies²" },
    bed: { en: "Bed", es: "Hab" },
    bath: { en: "Bath", es: "Baño" },
    filters: {
      type: { en: "ADU Type", es: "Tipo de ADU" },
      status: { en: "Status", es: "Estado" },
      size: { en: "Size", es: "Tamaño" },
      all: { en: "All", es: "Todos" },
      allSizes: { en: "All sizes", es: "Todos los tamaños" },
      clear: { en: "Clear filters", es: "Limpiar filtros" },
      results: { en: "projects", es: "proyectos" },
      noResults: {
        en: "No projects match these filters.",
        es: "Ningún proyecto coincide con estos filtros.",
      },
      statusDesign: { en: "Design", es: "Diseño" },
      statusPermits: { en: "Plans", es: "Planos" },
      statusConstruction: { en: "Construction", es: "Construcción" },
      statusCompleted: { en: "Completed", es: "Completado" },
      sizeUnder600: { en: "Under 600 sqft", es: "Menos de 600 pies²" },
      size600to800: { en: "600–800 sqft", es: "600–800 pies²" },
      size800to1000: { en: "800–1,000 sqft", es: "800–1,000 pies²" },
      sizeOver1000: { en: "1,000+ sqft", es: "1,000+ pies²" },
      builtFor: { en: "Built for", es: "Construida para" },
      builtForRental: { en: "Rental income", es: "Renta" },
      builtForLiveIn: { en: "Primary residence", es: "Residencia principal" },
      builtForFamily: { en: "Family / Multigenerational", es: "Familia / Multigeneracional" },
      builtForShortTerm: { en: "Short-term / Airbnb", es: "Corto plazo / Airbnb" },
    },
    map: {
      heading: { en: "Where we build", es: "Dónde construimos" },
      subheading: {
        en: "Every pin is a real EG Construction ADU across San Diego County.",
        es: "Cada pin es una ADU real construida por EG Construction en el Condado de San Diego.",
      },
      sectionLabel: { en: "Live Portfolio Map", es: "Mapa en Vivo" },
      cta: { en: "View Full Portfolio", es: "Ver Portafolio Completo" },
    },
  },

  roiCalculator: {
    pageTitle: { en: "ADU ROI Calculator", es: "Calculadora de ROI de ADU" },
    pageDesc: {
      en: "Calculate the return on investment of building an ADU and compare it against stocks, real estate, and savings accounts.",
      es: "Calcule el retorno de inversión de construir una ADU y compárelo con acciones, bienes raíces y cuentas de ahorro.",
    },
    heroTitle: { en: "What's the ROI of Your ADU?", es: "¿Cuál es el ROI de Tu ADU?" },
    heroSubtitle: {
      en: "Enter your project cost and estimated monthly rent to see how your ADU investment compares to traditional investments.",
      es: "Ingrese el costo de su proyecto y la renta mensual estimada para ver cómo su inversión en ADU se compara con inversiones tradicionales.",
    },
    projectCost: { en: "Project Cost", es: "Costo del Proyecto" },
    monthlyRent: { en: "Estimated Monthly Rent", es: "Renta Mensual Estimada" },
    annualRoi: { en: "Your ADU Annual ROI", es: "Tu ROI Anual de ADU" },
    paybackPeriod: { en: "Payback Period", es: "Período de Recuperación" },
    years: { en: "years", es: "años" },
    comparedTo: { en: "Compared to Other Investments", es: "Comparado con Otras Inversiones" },
    aduInvestment: { en: "Your ADU", es: "Tu ADU" },
    realEstate: { en: "Real Estate Avg.", es: "Bienes Raíces Prom." },
    stocks: { en: "Stocks Avg.", es: "Acciones Prom." },
    savings: { en: "Savings Account", es: "Cuenta de Ahorro" },
    ctaTitle: { en: "Ready to Start Your ADU Investment?", es: "¿Listo Para Comenzar Tu Inversión en ADU?" },
    ctaDesc: {
      en: "Talk to our team and get a personalized estimate for your property.",
      es: "Habla con nuestro equipo y obtén un estimado personalizado para tu propiedad.",
    },
    cta: { en: "Schedule Your Discovery Call", es: "Agenda Tu Llamada de Descubrimiento" },
    disclaimer: {
      en: "* This calculator provides estimates for educational purposes only. Actual returns may vary based on location, market conditions, and other factors.",
      es: "* Esta calculadora proporciona estimados solo con fines educativos. Los rendimientos reales pueden variar según la ubicación, condiciones del mercado y otros factores.",
    },
  },
  events: {
    pageTitle: { en: "ADU Open Houses in San Diego | EG Construction", es: "Casas Abiertas de ADU en San Diego | EG Construction" },
    pageDesc: {
      en: "Walk through real ADUs across San Diego. Meet homeowners, builders, and lenders. No pressure, no sales pitch — just real homes and honest answers.",
      es: "Recorre ADUs reales en San Diego. Conoce a propietarios, constructores y prestamistas. Sin presión, sin discurso de ventas — solo casas reales y respuestas honestas.",
    },

    heroBadge: { en: "San Diego · ADU Tours & Workshops", es: "San Diego · Tours y Talleres de ADU" },
    heroTitle: {
      en: "San Diego ADU Open Houses & Seminars",
      es: "Casas Abiertas y Seminarios de ADU en San Diego",
    },
    heroSubtitle: {
      en: "Tour real projects and learn how homeowners are creating extra income, space for family, and long-term value with ADUs.",
      es: "Recorre proyectos reales y descubre cómo los propietarios están generando ingresos extra, espacio para la familia y valor a largo plazo con las ADU.",
    },
    heroCta: { en: "RSVP Now", es: "Reserva Ahora" },
    heroCtaSecondary: { en: "Explore the map", es: "Explora el mapa" },

    // Featured Open House: Project RW (Bonita)
    openHouseEyebrow: { en: "Open Doors · Mid-Construction", es: "Puertas Abiertas · En Construcción" },
    openHouseTitle: { en: "Project RW — Bonita ADU", es: "Proyecto RW — ADU en Bonita" },
    openHouseDesc: {
      en: "Join us at our latest build: a 749 sq ft detached ADU with 2 bedrooms and 1 bathroom in Bonita, built on a hill with a retaining wall. A great opportunity to walk the site mid-construction, meet our expert team, and get your questions answered.",
      es: "Acompáñanos en nuestra obra más reciente: una ADU independiente de 749 pies² con 2 recámaras y 1 baño en Bonita, construida en ladera con muro de contención. Una gran oportunidad para recorrer la obra en construcción, conocer a nuestro equipo experto y resolver todas tus dudas.",
    },
    openHouseDate: { en: "Saturday, September 19 · 11:00 AM – 1:00 PM PST", es: "Sábado 19 de septiembre · 11:00 AM – 1:00 PM PST" },
    openHouseLocation: { en: "Bonita, CA (San Diego) — Bonita Mesa Rd", es: "Bonita, CA (San Diego) — Bonita Mesa Rd" },

    openHouseAddressNote: {
      en: "Full address sent once registered.",
      es: "La dirección completa se envía al registrarte.",
    },
    openHouseCta: { en: "RSVP Now", es: "Reserva Ahora" },

    whyEyebrow: { en: "Why attend", es: "Por qué asistir" },
    whyTitle: {
      en: "There's no better way to learn than walking through the door.",
      es: "No hay mejor forma de aprender que cruzando la puerta.",
    },
    whyBody: {
      en: "Reading about ADUs is one thing. Standing inside one — seeing how the light hits, how the space actually feels, talking to the person who built it — is something else entirely. That's what we're here for.",
      es: "Leer sobre ADUs es una cosa. Estar dentro de una — ver cómo entra la luz, cómo se siente el espacio, hablar con quien la construyó — es algo completamente distinto. Para eso estamos aquí.",
    },
    why1Title: { en: "See them in person", es: "Velas en persona" },
    why1Body: {
      en: "Photos don't tell the whole story. Come walk through finished ADUs of all shapes and sizes, from cozy backyard studios to full family suites, in neighborhoods all across San Diego.",
      es: "Las fotos no cuentan toda la historia. Recorre ADUs terminadas de todas las formas y tamaños, desde estudios acogedores en el patio hasta suites familiares completas, en vecindarios de todo San Diego.",
    },
    why2Title: { en: "Hear it straight from homeowners", es: "Escúchalo directo de los propietarios" },
    why2Body: {
      en: "The people who've been through it will be there — ready to tell you what they wish they'd known, what surprised them, and what they'd do differently.",
      es: "Las personas que ya pasaron por esto estarán ahí — listas para contarte qué les hubiera gustado saber, qué les sorprendió y qué harían diferente.",
    },
    why3Title: { en: "Get real answers from local experts", es: "Respuestas reales de expertos locales" },
    why3Body: {
      en: "Architects, builders, permit consultants, and lenders join us at select events. Bring your questions — the specific, complicated ones. That's exactly what they're there for.",
      es: "Arquitectos, constructores, consultores de permisos y prestamistas nos acompañan en eventos seleccionados. Trae tus preguntas — las específicas y complicadas. Para eso están ahí.",
    },

    mapEyebrow: { en: "See Real ADU Projects Across San Diego", es: "Mira Proyectos Reales de ADU en San Diego" },
    mapTitle: {
      en: "See what's happening in your neighborhood.",
      es: "Mira lo que está pasando en tu vecindario.",
    },
    mapSubtitle: {
      en: "Every ADU we're building, finishing, or planning is on this map. Filter by status to find one near you.",
      es: "Cada ADU que estamos construyendo, terminando o planeando está en este mapa. Filtra por estado para encontrar una cerca de ti.",
    },
    legendOpenHouse: { en: "Open House", es: "Casa Abierta" },
    legendCompleted: { en: "Completed", es: "Completado" },
    legendUnderConstruction: { en: "Under Construction", es: "En Construcción" },
    legendComingSoon: { en: "Coming Soon", es: "Próximamente" },
    filterShowAll: { en: "Show all", es: "Mostrar todos" },
    filterAriaGroup: { en: "Filter map by status", es: "Filtrar mapa por estado" },

    eventsEyebrow: { en: "Upcoming Events", es: "Próximos Eventos" },
    eventsTitle: {
      en: "Coming soon to a neighborhood near you.",
      es: "Próximamente cerca de ti.",
    },
    comingSoonBadge: { en: "Coming Soon", es: "Próximamente" },
    upcoming1Date: { en: "June 2026", es: "Junio 2026" },
    upcoming1Title: { en: "Finished ADU Showcase — Oceanside", es: "Showcase de ADU Terminada — Oceanside" },
    upcoming2Date: { en: "July 2026", es: "Julio 2026" },
    upcoming2Title: { en: "Expert Talk — ADU Types & Regulations", es: "Charla con Expertos — Tipos y Regulaciones de ADU" },
    joinWaitlist: { en: "Join the Waitlist", es: "Únete a la Lista de Espera" },
    upcomingSubtitle: {
      en: "Save your spot — space is limited and the full address is sent after you register.",
      es: "Aparta tu lugar — el cupo es limitado y la dirección completa se envía al registrarte.",
    },
    pastEyebrow: { en: "Past Events", es: "Eventos Anteriores" },
    pastTitle: {
      en: "Where we've opened the doors.",
      es: "Donde ya abrimos las puertas.",
    },
    pastSubtitle: {
      en: "A record of the open houses and job-site tours we've hosted across San Diego County.",
      es: "Un registro de las casas abiertas y recorridos de obra que hemos realizado en el Condado de San Diego.",
    },
    pastBadge: { en: "Completed", es: "Realizado" },
    eventWhen: { en: "When", es: "Cuándo" },
    eventWhere: { en: "Where", es: "Dónde" },
    eventDetails: { en: "Project details", es: "Detalles del proyecto" },

    formEyebrow: { en: "Stay in the loop", es: "Mantente al tanto" },
    formTitle: {
      en: "Ready to stop wondering and start seeing?",
      es: "¿Listo para dejar de preguntarte y empezar a ver?",
    },
    formDesc: {
      en: "Sign up and we'll send you a heads-up when new open houses or workshops are added. It costs nothing, and you can unsubscribe whenever you want.",
      es: "Regístrate y te avisaremos cuando agreguemos nuevas casas abiertas o talleres. No cuesta nada y puedes cancelar la suscripción cuando quieras.",
    },

    viewProject: { en: "View Full Project", es: "Ver Proyecto Completo" },
    sqft: { en: "sqft", es: "pies²" },
    bedsBaths: { en: "bd / ba", es: "hab / ba" },
  },
  floorPlans: {
    eyebrow: { en: "ADU Floor Plans", es: "Planos de ADU" },
    heroTitle: { en: "Floor Plans", es: "Planos" },
    heroSubtitle: {
      en: "Discover the perfect ADU floor plan for your San Diego property. Each design is thoughtfully crafted to maximize space, comfort, and rental value — and every plan is fully customizable.",
      es: "Descubre el plano de ADU perfecto para tu propiedad en San Diego. Cada diseño está cuidadosamente creado para maximizar espacio, comodidad y valor de renta — y todos son totalmente personalizables.",
    },
    primaryCta: { en: "Schedule Your Discovery Call", es: "Agenda tu Llamada de Descubrimiento" },
    viewPlans: { en: "View Plans", es: "Ver Planos" },
    viewPlan: { en: "View Plan", es: "Ver Plano" },
    clientsFavorite: { en: "Clients Favorite", es: "Favorito de Clientes" },
    results: { en: "results", es: "resultados" },
    result: { en: "result", es: "resultado" },
    smallTitle: { en: "Small Floor Plans", es: "Planos Pequeños" },
    smallDesc: { en: "Under 600 sqft — studios and compact 1 bedrooms.", es: "Menos de 600 pies² — estudios y 1 habitación compactos." },
    mediumTitle: { en: "Medium Floor Plans", es: "Planos Medianos" },
    mediumDesc: { en: "600 – 900 sqft — 1 to 2 bedrooms with comfortable living areas.", es: "600 – 900 pies² — 1 a 2 habitaciones con áreas de estar cómodas." },
    largeTitle: { en: "Large Floor Plans", es: "Planos Grandes" },
    largeDesc: { en: "Over 900 sqft — spacious 2 to 3 bedroom designs for families.", es: "Más de 900 pies² — diseños espaciosos de 2 a 3 habitaciones para familias." },
    emptyState: {
      en: "We're publishing new floor plans soon. Schedule a Discovery Call and we'll walk you through every option that fits your lot.",
      es: "Pronto publicaremos nuevos planos. Agenda una Llamada de Descubrimiento y te mostraremos todas las opciones que caben en tu terreno.",
    },
    bedroom: { en: "BR", es: "Hab" },
    bathroom: { en: "BA", es: "Baño" },
    sqft: { en: "sqft", es: "pies²" },
    customizable: { en: "Customize any design to suit your individual needs.", es: "Personaliza cualquier diseño según tus necesidades." },
    backToPlans: { en: "Back to All Plans", es: "Volver a Todos los Planos" },
    overview: { en: "Overview", es: "Descripción" },
    floorPlanLabel: { en: "Floor Plan", es: "Plano" },
    keyFeatures: { en: "Key Features", es: "Características Clave" },
    ctaBandTitle: { en: "Found a plan you love?", es: "¿Encontraste un plano que te gusta?" },
    ctaBandDesc: {
      en: "Every floor plan can be customized for your lot, budget, and family needs. Let's talk through the options.",
      es: "Cada plano se puede personalizar para tu terreno, presupuesto y necesidades familiares. Hablemos de las opciones.",
    },
    navLabel: { en: "Floor Plans", es: "Planos" },
    floorPlanOptions: { en: "Floor Plan Options", es: "Opciones de Plano" },
    multiAduBadge: { en: "Multi-ADU Project", es: "Proyecto Multi-ADU" },
    filtersTitle: { en: "Filter Plans", es: "Filtrar Planos" },
    showFilters: { en: "Filters", es: "Filtros" },
    hideFilters: { en: "Hide Filters", es: "Ocultar Filtros" },
    clearFilters: { en: "Clear all", es: "Limpiar todo" },
    showingCount: { en: "Showing", es: "Mostrando" },
    of: { en: "of", es: "de" },
    plans: { en: "plans", es: "planos" },
    noResultsTitle: { en: "No plans match your filters", es: "Ningún plano coincide con tus filtros" },
    noResultsDesc: {
      en: "Try adjusting size, bedrooms, or clear your filters to see all plans.",
      es: "Prueba ajustando tamaño, recámaras o limpia los filtros para ver todos los planos.",
    },
    searchPlaceholder: { en: "Search by name or city…", es: "Buscar por nombre o ciudad…" },
    sortBy: { en: "Sort by", es: "Ordenar por" },
    sortFeatured: { en: "Featured", es: "Destacados" },
    sortSqftAsc: { en: "Smallest first", es: "Menor tamaño primero" },
    sortSqftDesc: { en: "Largest first", es: "Mayor tamaño primero" },
    sortBedsDesc: { en: "Most bedrooms", es: "Más recámaras" },
    sortNameAsc: { en: "Name A–Z", es: "Nombre A–Z" },
    filterSize: { en: "Size", es: "Tamaño" },
    filterBedrooms: { en: "Bedrooms", es: "Recámaras" },
    filterBathrooms: { en: "Bathrooms", es: "Baños" },
    filterType: { en: "Type", es: "Tipo" },
    filterCity: { en: "City", es: "Ciudad" },
    filterSqftRange: { en: "Square footage", es: "Pies cuadrados" },
    optAll: { en: "All", es: "Todos" },
    optAny: { en: "Any", es: "Cualquiera" },
    optStudio: { en: "Studio", es: "Estudio" },
    optNewAdu: { en: "New ADU", es: "ADU Nuevo" },
    optGarageConversion: { en: "Garage Conversion", es: "Conversión de Garaje" },
    optMultiAdu: { en: "Multi-ADU", es: "Multi-ADU" },
    optSmall: { en: "Small", es: "Pequeño" },
    optMedium: { en: "Medium", es: "Mediano" },
    optLarge: { en: "Large", es: "Grande" },
    statTotalPlans: { en: "Floor Plans", es: "Planos" },
    statSqftRange: { en: "Sqft Range", es: "Rango Pies²" },
    statCities: { en: "San Diego Cities", es: "Ciudades San Diego" },
    statCustomizable: { en: "Fully Customizable", es: "Totalmente Personalizables" },
    photoCount: { en: "photos", es: "fotos" },
    garageBadge: { en: "Garage Conversion", es: "Conversión Garaje" },
  },
  bounce: {
    stickyText: { en: "Talk to an ADU expert", es: "Habla con un experto en ADU" },
    stickyCta: { en: "Schedule", es: "Agenda" },
    stickyCall: { en: "Call", es: "Llamar" },
    miniTitle: { en: "Get a free 15-min Discovery Call", es: "Agenda una llamada gratis de 15 min" },
    miniName: { en: "Your name", es: "Tu nombre" },
    miniPhone: { en: "Phone number", es: "Número de teléfono" },
    miniTiming: { en: "When do you want to start?", es: "¿Cuándo quieres empezar?" },
    miniTimingSoon: { en: "In 3–6 months", es: "En 3–6 meses" },
    miniTimingLater: { en: "In 6–12 months", es: "En 6–12 meses" },
    miniTimingExplore: { en: "Just exploring", es: "Solo explorando" },
    miniCta: { en: "Schedule my Discovery Call", es: "Agenda mi Discovery Call" },
    miniInvalid: { en: "Please enter a valid name and US phone number.", es: "Ingresa un nombre y un teléfono válido." },
    nextStepLabel: { en: "Where would you like to go next?", es: "¿A dónde quieres ir ahora?" },
    chipProjects: { en: "See completed projects", es: "Ver proyectos completados" },
    chipRoi: { en: "Calculate my ROI", es: "Calcular mi ROI" },
    chipPlans: { en: "Browse floor plans", es: "Ver planos disponibles" },
    relatedTitle: { en: "You might also like", es: "También te puede interesar" },
    exitTitle: { en: "Before you go —", es: "Antes de irte —" },
    exitBody: { en: "Get 15 minutes with our team to see if your lot qualifies for an ADU. No pressure, no cost.", es: "Toma 15 min con nuestro equipo para ver si tu lote califica. Sin presión, sin costo." },
    exitCta: { en: "Schedule my Discovery Call", es: "Agenda mi Discovery Call" },
    exitDismiss: { en: "No thanks", es: "No, gracias" },
  },
} as const;


export function t(obj: { en: string; es: string }, lang: Lang): string {
  return obj[lang];
}
